import { Users } from 'lucide-react';
import './InvestorsInInvestment.scss';

const InvestorsInInvestment = ({ investmentDetails }) => {
  const investors = Array.isArray(investmentDetails?.investors)
    ? investmentDetails.investors
    : [];

  return (
    <div className="ii-root">
      <div className="ii-header">
        <Users size={16} className="ii-header-icon" />
        <span className="ii-header-count">{investors.length} investidores</span>
      </div>

      {investors.length === 0 ? (
        <div className="ii-empty">
          <Users size={36} className="ii-empty-icon" />
          <p>Nenhum investidor encontrado</p>
        </div>
      ) : (
        <div className="ii-table-wrapper">
          <table className="ii-table">
            <thead>
              <tr>
                <th>Investidor</th>
                <th>Área</th>
                <th>Nível</th>
                <th>Nota</th>
                <th>Aportes ativos</th>
                <th>Avaliações</th>
                <th>Última avaliação</th>
              </tr>
            </thead>
            <tbody>
              {investors.map((investor, i) => {
                const emp = investor?.employee;
                const person = emp?.person;
                return (
                  <tr key={emp?.id ?? i}>
                    <td className="ii-name">
                      <div className="ii-avatar">
                        {person?.name?.[0]?.toUpperCase() ?? '?'}
                      </div>
                      <span>{person?.name ?? '—'}</span>
                    </td>
                    <td>{emp?.unit ?? '—'}</td>
                    <td>{emp?.role ?? '—'}</td>
                    <td>{investor?.value?.toFixed(1) ?? '—'}</td>
                    <td>{investor?.taskMetrics?.activeExecutions ?? 0}</td>
                    <td>{investor?.evaluationCount ?? 0}</td>
                    <td>
                      {investor?.lastEvaluationAt
                        ? new Date(investor.lastEvaluationAt).toLocaleDateString('pt-BR')
                        : '—'}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default InvestorsInInvestment;
